import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROSPECT_CAMPAIGNS_PAGE_SIZE,
  ADMIN_PROSPECT_CAMPAIGN_TARGETS_PAGE_SIZE,
  ADMIN_PROSPECT_CAMPAIGN_MAILINGS_PAGE_SIZE,
  ADMIN_PROSPECT_CAMPAIGN_NAME_MAX,
  buildCreateAdminProspectCampaignRequest,
  buildGenerateAdminProspectCampaignLettersRequest,
  buildGetAdminProspectCampaignLetterArchiveDownloadUrlRequest,
  buildGetAdminProspectCampaignLetterDownloadUrlRequest,
  buildGetAdminProspectCampaignRequest,
  buildListAdminProspectCampaignMailingsRequest,
  buildListAdminProspectCampaignsRequest,
  buildListAdminProspectCampaignTargetsRequest,
  buildPrepareAdminProspectCampaignMailingsRequest,
  buildRequestAdminProspectCampaignLetterArchiveRequest,
  buildRetryAdminProspectCampaignLetterArchiveRequest,
  buildRetryAdminProspectCampaignBuildRequest,
  buildRetryAdminProspectCampaignMailingBuildRequest,
  createAdminProspectCampaignCreateAttempt,
  createAdminProspectCampaignOperationAttempt,
  generateAdminProspectCampaignOperationId,
} from './prospectCampaignsRequest.js';
import {
  parseGenerateAdminProspectCampaignLettersResponse,
  parseGetAdminProspectCampaignLetterArchiveDownloadUrlResponse,
  parseGetAdminProspectCampaignLetterDownloadUrlResponse,
  parseListAdminProspectCampaignMailingsResponse,
  parsePrepareAdminProspectCampaignMailingsResponse,
  parseRequestAdminProspectCampaignLetterArchiveResponse,
  parseRetryAdminProspectCampaignLetterArchiveResponse,
  parseRetryAdminProspectCampaignBuildResponse,
  parseRetryAdminProspectCampaignMailingBuildResponse,
} from './prospectCampaignsResponse.js';

export {
  ADMIN_PROSPECT_CAMPAIGNS_PAGE_SIZE,
  ADMIN_PROSPECT_CAMPAIGN_TARGETS_PAGE_SIZE,
  ADMIN_PROSPECT_CAMPAIGN_MAILINGS_PAGE_SIZE,
  ADMIN_PROSPECT_CAMPAIGN_NAME_MAX,
  buildCreateAdminProspectCampaignRequest,
  buildGenerateAdminProspectCampaignLettersRequest,
  buildGetAdminProspectCampaignLetterArchiveDownloadUrlRequest,
  buildGetAdminProspectCampaignLetterDownloadUrlRequest,
  buildGetAdminProspectCampaignRequest,
  buildListAdminProspectCampaignMailingsRequest,
  buildListAdminProspectCampaignsRequest,
  buildListAdminProspectCampaignTargetsRequest,
  buildPrepareAdminProspectCampaignMailingsRequest,
  buildRequestAdminProspectCampaignLetterArchiveRequest,
  buildRetryAdminProspectCampaignLetterArchiveRequest,
  buildRetryAdminProspectCampaignBuildRequest,
  buildRetryAdminProspectCampaignMailingBuildRequest,
  createAdminProspectCampaignCreateAttempt,
  createAdminProspectCampaignOperationAttempt,
  generateAdminProspectCampaignOperationId,
};

export {
  parseGenerateAdminProspectCampaignLettersResponse,
  parseGetAdminProspectCampaignLetterArchiveDownloadUrlResponse,
  parseGetAdminProspectCampaignLetterDownloadUrlResponse,
  parseListAdminProspectCampaignMailingsResponse,
  parsePrepareAdminProspectCampaignMailingsResponse,
  parseRequestAdminProspectCampaignLetterArchiveResponse,
  parseRetryAdminProspectCampaignLetterArchiveResponse,
  parseRetryAdminProspectCampaignBuildResponse,
  parseRetryAdminProspectCampaignMailingBuildResponse,
};

export async function createAdminProspectCampaign(payload) {
  const fn = httpsCallable(functions, 'createAdminProspectCampaign');
  const { data } = await fn(payload);
  return data;
}

export async function listAdminProspectCampaigns(request) {
  const fn = httpsCallable(functions, 'listAdminProspectCampaigns');
  const { data } = await fn(request);
  return data;
}

export async function getAdminProspectCampaign(campaignId) {
  const fn = httpsCallable(functions, 'getAdminProspectCampaign');
  const { data } = await fn(buildGetAdminProspectCampaignRequest({ campaignId }));
  return data;
}

export async function listAdminProspectCampaignTargets(request) {
  const fn = httpsCallable(functions, 'listAdminProspectCampaignTargets');
  const { data } = await fn(request);
  return data;
}

export async function prepareAdminProspectCampaignMailings(payload) {
  const fn = httpsCallable(functions, 'prepareAdminProspectCampaignMailings');
  const { data } = await fn(payload);
  return parsePrepareAdminProspectCampaignMailingsResponse(data);
}

export async function retryAdminProspectCampaignBuild(payload) {
  const fn = httpsCallable(functions, 'retryAdminProspectCampaignBuild');
  const { data } = await fn(payload);
  return parseRetryAdminProspectCampaignBuildResponse(data);
}

export async function retryAdminProspectCampaignMailingBuild(payload) {
  const fn = httpsCallable(functions, 'retryAdminProspectCampaignMailingBuild');
  const { data } = await fn(payload);
  return parseRetryAdminProspectCampaignMailingBuildResponse(data);
}

export async function generateAdminProspectCampaignLetters(payload) {
  const fn = httpsCallable(functions, 'generateAdminProspectCampaignLetters');
  const { data } = await fn(payload);
  return parseGenerateAdminProspectCampaignLettersResponse(data);
}

export async function listAdminProspectCampaignMailings(request) {
  const fn = httpsCallable(functions, 'listAdminProspectCampaignMailings');
  const { data } = await fn(request);
  return parseListAdminProspectCampaignMailingsResponse(data);
}

export async function getAdminProspectCampaignLetterDownloadUrl(request) {
  const fn = httpsCallable(functions, 'getAdminProspectCampaignLetterDownloadUrl');
  const { data } = await fn(request);
  return parseGetAdminProspectCampaignLetterDownloadUrlResponse(data);
}

export async function requestAdminProspectCampaignLetterArchive(payload) {
  const fn = httpsCallable(functions, 'requestAdminProspectCampaignLetterArchive');
  const { data } = await fn(payload);
  return parseRequestAdminProspectCampaignLetterArchiveResponse(data);
}

export async function retryAdminProspectCampaignLetterArchive(payload) {
  const fn = httpsCallable(functions, 'retryAdminProspectCampaignLetterArchive');
  const { data } = await fn(payload);
  return parseRetryAdminProspectCampaignLetterArchiveResponse(data);
}

export async function getAdminProspectCampaignLetterArchiveDownloadUrl(request) {
  const fn = httpsCallable(functions, 'getAdminProspectCampaignLetterArchiveDownloadUrl');
  const { data } = await fn(request);
  return parseGetAdminProspectCampaignLetterArchiveDownloadUrlResponse(data);
}
